import axios from "axios";

export const changeProfessionalTournamentStatus = async (id, status, token) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/changeProfessionalTournamentStatus`,
      {
        id,
        status,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};
